const COMMA_LANGUAGES = [
  'bg',
  'cs',
  'da',
  'de',
  'el',
  'es',
  'et',
  'fi',
  'fr',
  'hr',
  'hu',
  'it',
  'lt',
  'lv',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'sl',
  'sr',
  'sv',
  'tr',
];

export default function abbrev(lang, value, decimals = 2) {
  if (!value) {
    return '';
  }

  decimals = Math.pow(10, decimals);
  const abbrev = ['k', 'm', 'b', 't'];

  for (let i = abbrev.length - 1; i >= 0; i--) {
    const size = Math.pow(10, (i + 1) * 3);
    if (size <= value) {
      value = Math.round((value * decimals) / size) / decimals;

      if (value === 1000 && i < abbrev.length - 1) {
        value = 1;
        i++;
      }

      value += abbrev[i];
      break;
    }
  }

  if (COMMA_LANGUAGES.includes(lang)) {
    return value.toString().replace('.', ',');
  }
  return value;
}
